import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { OpsUnit } from 'icreate/common/models/ops-unit';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class OpsUnitService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getList(vesselId: string) {
        return await lastValueFrom(
            this.http.get<OpsUnit[]>(`${this.domain}/api/opsUnit`, {
                headers: this.headers,
                params: { vesselId },
            })
        );
    }

    async create(opsUnitData: OpsUnit) {
        return await lastValueFrom(
            this.http.post<OpsUnit>(`${this.domain}/api/opsUnit`, opsUnitData, {
                headers: this.headers,
            })
        );
    }

    async duplicateOpsUnit(opsUnitData: OpsUnit) {
        return await lastValueFrom(
            this.http.post<OpsUnit>(`${this.domain}/api/opsUnit/copy`, opsUnitData, {
                headers: this.headers,
            })
        );
    }

    async update(opsUnitData: OpsUnit) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/opsUnit/${opsUnitData.id}`, opsUnitData, {
                headers: this.headers,
            })
        );
    }

    async deleteOpsUnit(opsUnitId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/opsUnit/${opsUnitId}`));
    }
}
